import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import es from '../../lang/es.json'
import fr from '../../lang/fr.json'
import it from '../../lang/it.json'
import pt from '../../lang/pt.json'
import zh from '../../lang/zh.json'
import cs from '../../lang/cs.json'
import de from '../../lang/de.json'
import hu from '../../lang/hu.json'
import pl from '../../lang/pl.json'
import ro from '../../lang/ro.json'
import en from '../../lang/en.json'

// "general" is the default namespace: keys like t("save") resolve to en.general.save
// "root" is the fallback namespace: keys like t("account.TOTAL_HOURS") resolve to en.account.TOTAL_HOURS
const resources = {
  en: {
    general: en.general,
    root: en
  },
  fr: {
    general: fr.general,
    root: fr
  },
  es: {
    general: es.general,
    root: es
  },
  it: {
    general: it.general,
    root: it
  },
  pt: {
    general: pt.general,
    root: pt
  },
  zh: {
    general: zh.general,
    root: zh
  },
  cs: {
    general: cs.general,
    root: cs
  },
  de: {
    general: de.general,
    root: de
  },
  hu: {
    general: hu.general,
    root: hu
  },
  pl: {
    general: pl.general,
    root: pl
  },
  ro: {
    general: ro.general,
    root: ro
  }
}

export const getMyGameLanguage = () => {
  if (typeof window !== 'undefined' && window.localStorage && typeof window.localStorage.getItem === 'function') {
    return window.localStorage.getItem('mg-language') || 'en'
  }
  return 'en' // Fallback sécurisé pour l'environnement de test (Node)
}

void i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    defaultNS: 'general',
    fallbackNS: 'root',
    lng: getMyGameLanguage(),
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      // support both legacy react-redux-i18n format %{var} and i18next format {{var}}
      prefix: undefined,
      suffix: undefined,
      prefixEscaped: String.raw`(?:%\{|\{\{)`,
      suffixEscaped: String.raw`\}\}?`
    }
  })

export default i18n
